const values = {
    "FINANCE": "Finanza",
    "FINANCES": "Finanzas",
    "BILLING_PERIODS": "Períodos de Facturación",
    "FINANCIAL": "Financiero",
    "BILLING_PERIOD_DETAILS": "Detalles del Período de Facturación",
    "NO_BILLING_PERIODS_TITLE": "No hay períodos de facturación!!!",
    "NO_BILLING_PERIODS_SUBTITLE": "Verifica si estás aplicando algún filtro",
    "BILLING_PERIOD_FILTER_PLACEHOLDER": "Descripción",
    "EDIT_BILLING_PERIOD": "Editar Período",
    "NEW_BILLING_PERIOD": "Nuevo Período",
    "REMOVE_BILLING_PERIOD": "Eliminar Período",
    "REMOVE_BILLING_PERIOD_CONFIRMATION": "¿Está seguro que desea eliminar el período de facturación?",
    "BILL_BILLING_PERIOD_CONFIRMATION": "¿Está seguro que desea facturar el perído? Será debitado al saldo de las agencias.",
}

export default values;